export const featureName = 'ticket';